module.exports = __webpack_public_path__ + "dfc84bc9e62c0f16233bf01fb62d9ccd.fbx";